"use client";

import type { FeatureCollection } from "geojson";
import { RMapContextProvider } from "maplibre-react-components";
import React, { type ReactElement } from "react";
import { WeatherPanelLegend, WeatherMap } from "@/components";

interface WaterMainProps {
  features: FeatureCollection;
}

function WaterMain({ features }: Readonly<WaterMainProps>): ReactElement {
  return (
    <div className="h-[calc(100vh-56px)]">
      <RMapContextProvider>
        <WeatherPanelLegend counter={features.features.length} />
        <WeatherMap features={features} />
      </RMapContextProvider>
    </div>
  );
}

export { WaterMain, type WaterMainProps };
